import {Component, inject, input, OnInit} from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import {EstadoSeguimiento, Objetivos as ObjetivosInterface} from './objetivos.interface';
import {ObjetivosService} from './objetivos.service';
import {ErrorService} from '../../../../../../shared/services/error.service';
import {SnackbarService} from '@shared/services/snackbar.service';
import {DeleteTrigger} from '../../../../../../shared/components/ui/delete-trigger/delete-trigger';
import {DataTable, TableCellDirective, TableColumn} from '../../../../../../shared/components/ui/list-components';
import {PageHeaderComponent} from '../../../../../../shared/components/common/page-header/page-header.component';
import {GenericHttpResponse} from '../../../../../../shared/services/interfaces/generic-http-response.interface';
import {HttpErrorResponse} from '@angular/common/http';
import {DialogService} from '@shared/services/dialog.service';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {CrearObjetivo} from './crear-objetivo/crear-objetivo';
import {DetalleObjetivo} from './detalle-objetivo/detalle-objetivo';
import {objetivoLabel} from './objetivos.util';
import {Badge} from '@shared/components/ui/badge/badge';
import {ProgressBar} from '@shared/components/ui/progress-bar/progress-bar';
import {avanceVisual, ESTADOS_SEGUIMIENTO, resumenObjetivos, ResumenObjetivos} from './seguimiento-objetivo.util';

@Component({
  selector: 'app-objetivos',
  imports: [
    HasPermissionDirective,
    PageHeaderComponent,
    Badge,
    MatIcon,
    MatTooltip,
    DeleteTrigger,
    DataTable,
    TableCellDirective,
    ProgressBar,
  ],
  templateUrl: './objetivos.html',
})
export class Objetivos implements OnInit {
  readonly permissionAuth = inject(AuthenticationService);

  protected readonly objetivoLabel = objetivoLabel;
  protected estadoSeguimiento(estado: EstadoSeguimiento) { return ESTADOS_SEGUIMIENTO[estado]; }
  protected readonly avanceVisual = avanceVisual;

  clienteId = input.required<number>();

  loading = false;
  deleting = false;
  deletingIndex: number | null = null;
  objetivos: ObjetivosInterface[] = [];
  resumen: ResumenObjetivos = resumenObjetivos([]);

  columns: TableColumn[] = [
    { key: 'periodo.nombre', header: 'Período' },
    { key: 'contrato', header: 'Contrato' },
    { key: 'establecimiento', header: 'Establecimiento' },
    { key: 'objetivo', header: 'Objetivo' },
    { key: 'cantidad_preneces_proyectadas', header: 'Preñeces Proyectadas' },
    { key: 'cantidad_donantes', header: 'Plantel de donantes' },
    { key: 'avance', header: 'Avance de preñeces', width: '220px' },
    { key: 'pendientes', header: 'Diagnósticos pendientes' },
    { key: 'estado', header: 'Estado' },
    { key: 'acciones', header: 'Acciones', width: '1%' },
  ];

  private objetivosService = inject(ObjetivosService);
  private errorService = inject(ErrorService);
  private snackbarService = inject(SnackbarService);
  private dialogService = inject(DialogService);

  ngOnInit(): void {
    this.getObjetivos();
  }

  getObjetivos(): void {
    this.loading = true;
    this.objetivosService.index(this.clienteId()).subscribe({
      next: (response: GenericHttpResponse<ObjetivosInterface[]>) => {
        if (response.status && response.data) {
          this.objetivos = response.data;
          this.resumen = resumenObjetivos(this.objetivos);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  openCreateModal(): void {
    this.dialogService.openForm(CrearObjetivo, {
      size: 'md',
      data: this.clienteId()
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getObjetivos();
      }
    });
  }

  openViewModal(id: number): void {
    this.dialogService.openForm(DetalleObjetivo, {
      size: 'xl',
      data: {
        objetivoId: id,
        clienteId: this.clienteId()
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getObjetivos();
      }
    });
  }

  delete(id: number, index: number): void {
    this.deleting = true;
    this.deletingIndex = index;

    this.objetivosService.destroy(id).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Objetivo eliminado correctamente');
          this.getObjetivos();
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.deleting = false;
      this.deletingIndex = null;
    });
  }
}
